import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormTitleClassesDirective } from '../directives/form-title-classes.directive';
import { MbsSize } from '../utils';

export type FormSectionSize = MbsSize.sm | MbsSize.lg;
export type FormSectionTitleSize = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
const host = 'mbs-form-section';

@Component({
  selector: 'mbs-form-section',
  templateUrl: 'form-section.component.html',
  host: {
    '[class]': 'hostClasses()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormTitleClassesDirective, NgTemplateOutlet]
})
export class FormSectionComponent {
  /**
   * Title text for a form section
   */
  public readonly title = input<string>(null);

  /**
   * Custom classes for form section title
   */
  public readonly titleClasses = input<string>(null);

  /**
   * Will set icon(s) to left `form-section`
   */
  public readonly icon = input<string>(null);

  /**
   * Implements one of form section size
   * Possible values: 'MbsSize.sm' | 'MbsSize.lg'
   */
  public readonly size = input<FormSectionSize>(null);

  /**
   * Implements one of the title size
   * Possible values: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
   */
  public readonly titleSize = input<FormSectionTitleSize>('h5');

  protected readonly hostClasses = computed<string>(() => {
    const size = this.size();

    return size ? `${host} -${size}` : host;
  });

  protected readonly computedTitleClasses = computed<string>(() => {
    const titleClass = `${host}_title`;
    const titleClasses = this.titleClasses();

    return titleClasses ? `${titleClass} ${titleClasses}` : titleClass;
  });
}
